<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="title"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="createMember"
          >
            {{ $t("create_member") }}
          </button>
        </div>
      </div>
    </div>

    <app-table :options="options" :id="tableId" @action="getListAction" />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../core/helpers/app/AppFunction";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      title: '',
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      rowData: {},
      tableId: "advance-table",
      options: {
        name: "AdvanceTable",
        url: actions.MEMBERSHIP_BUYERS,
        showHeader: true,
        columns: [
          // {
          //     title: this.$t('date'),
          //     type: 'media-object',
          //     key: 'media-object',
          //     mediaTitleKey: 'name',
          //     mediaSubtitleKey: 'email',
          //     default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
          //     modifier: (value, row) => {
          //         return value; // imag url
          //     },
          //     isVisible: true
          // },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "company",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";
              let newS = "";
              if (value.status === "active") {
                newS = "Active";
                ClassName = `success`;
              } else if (value.status === "inactive") {
                ClassName = `warning`;
                newS = "Inactive";
              }

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                newS
              )}</span>`;
            },
          },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "company",
            modifier: (value) => {
              if (value != "") {
                return `<span>${this.$t(
                  value.start_date ? value.start_date : "---"
                )}</span>`;
              }
            },
          },
          {
            title: this.$t("end_date"),
            type: "custom-html",
            key: "company",
            modifier: (value) => {
              if (value != "") {
                return `<span>${this.$t(
                  value.end_date ? value.end_date : "---"
                )}</span>`;
              }
            },
          },
          {
            title: this.$t("business_category"),
            type: "custom-html",
            key: "company",
            modifier: (value) => {
              let a = value.category.title ?? "---";
              return `<span>${this.$t(a)}</span>`;
            },
          },
          {
            title: this.$t("company_name"),
            type: "custom-html",
            key: "company",
            modifier: (value, row) => {
              return `<a href="#" id="${row.id}" @click=${this.myFunction(row.id)}>${this.$t(value.company_name)}</a>`;
            },
          },
          {
            title: this.$t("amount_due"),
            type: "custom-html",
            key: "company",
            modifier: (value, row) => {
              return `<span>${
                value.invoice ? value.invoice.amount_due : "0"
              }</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view_history_report"),
            icon: "eye",
            type: "none",
          },
          {
            title: this.$t("view_profile"),
            icon: "eye",
            type: "none",
          },
        ],
        filters: [
          {
            title: this.$t("date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "nextYear"],
          },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          {
            title: this.$t("status"),
            type: "checkbox",
            key: "status",
            option: [
              { id: "active", value: "Active" },
              { id: "inactive", value: "Inactive" },
              // {id: 'invited', value: 'Invited'},
            ],
          },
          // {
          //   title: this.$t("role"),
          //   type: "radio",
          //   key: "roles",
          //   option: [
          //     { id: "buyer", value: "Buyer" },
          //     { id: "supplier", value: "Supplier" },
          //   ],
          //   header: {
          //     title: this.$t("want_to_filter_your_list"),
          //     description: this.$t(
          //       "you_can_filter_your_data_table_which_are_created_based_on_gender"
          //     ),
          //   },
          // },
          {
            title: this.$t("search_and_select_by_company_name"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    /**
     * for open add edit modal
     */
    createMember() {
      window.location = "/admin/membership/create";
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("view_history_report")) {
        // window.location =
        //   "/admin/membership/company/report/" + rowData.company.id;
        this.view_history(rowData.company.id)
      } else if (actionObj.title == this.$t("view_profile")) {
         this.view(rowData.id)
      }
    },
      view(id) {
          this.active = 4;
          this.$emit("user", id);
        },
        myFunction(id){
            let doc = document.getElementById(id);
            if(doc){
                doc.addEventListener('click', () => {
                this.view(id);
            }); 
            }
        },
        view_history(id){
          this.active = 2;
          this.$emit("id", id);
        },
    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.MEMBERSHIP}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      let myLocation = location.href;
      let split = myLocation.split("/");
      let role = split[5].split("?")[0];
      let url = actions.MEMBER_SEARCH_SELECT_BUYERS_COMPANY_NAME+'?role='+role;
      this.axiosGet(url).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select_by_company_name")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.value,
            value: name.value,
          };
        });
      });
    },
    setMemberRole()
    {
      let myLocation = location.href;
      let split = myLocation.split("/");
      let role = split[5].split("?")[0];
      this.options.url = actions.MEMBERSHIP_BUYERS+'?role='+role;
      
      if (role == 'supplier') {
        this.title = this.$t('supplier_memberships');
      }
      else
      {
         this.title =  this.$t('buyer_memberships');
      }
    }
  },
  mounted(){
    
     this.setMemberRole();
  }
};
</script>
